import React from 'react';
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, Inject, PieSeries}
from'@syncfusion/ej2-react-charts';

const Pie = () => {
  return (
    <div>Pie</div>
  )
}

export default Pie